// @flow

import * as React from 'react';
import './Checklist.scss';
import {List} from '../List/List';

type ChecklistProps = {|
  id: string,
  children?: React.Node,
|};

export const Checklist = (props: ChecklistProps) => {
  return <List className="Checklist" type="list-style-none" {...props} />;
};
